import {makeAutoObservable} from "mobx";
import {inject, injectable} from "inversify";
import {MouseEvent} from "react";
import {AxiosError} from "axios";
import {ViewController} from "data/types/structure";
import {Bindings} from "data/constants/bindings";
import type {IPromoBannerStore, IPrompt} from "data/stores/promo_banner/promo_banner.store";
import {GAME_ZONE_URL} from "data/constants";
import {IAxiosApiError} from "data/types/api";
import type {IModalsStore} from "data/stores/modals/modals.store";

export interface IPromoBannerController extends ViewController {
	get prompt(): IPrompt | null;
	get className(): string;

	submitHandler: (e: MouseEvent) => void;
	closeHandler: (e: MouseEvent) => void;
}

@injectable()
export class PromoBannerController implements IPromoBannerController {
	get prompt() {
		return this._promoBannerStore.prompt;
	}

	get className() {
		return this._promoBannerStore.isShowAnimation ? "prompt animated" : "prompt";
	}

	constructor(
		@inject(Bindings.PromoBannerStore) private _promoBannerStore: IPromoBannerStore,
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	submitHandler = (e: MouseEvent) => {
		e.stopPropagation();

		window.location.href = `${GAME_ZONE_URL}fantasy`;
	};

	closeHandler = async (e: MouseEvent) => {
		const type = this.prompt?.type;

		if (!type) return;

		try {
			e.stopPropagation();
			await this._promoBannerStore.close({type});
		} catch (e) {
			const error = e as AxiosError<IAxiosApiError, unknown>;
			this._modalsStore.showAxiosError(error);
		}
	};

	init() {
		return;
	}

	dispose() {
		return;
	}
}
